import { render, staticRenderFns } from "./sso.vue?vue&type=template&id=e2497be8&scoped=true"
import script from "./sso.vue?vue&type=script&lang=js"
export * from "./sso.vue?vue&type=script&lang=js"
import style0 from "./sso.vue?vue&type=style&index=0&id=e2497be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2497be8",
  null
  
)

export default component.exports